import "./CompanySwitch.css";
import api from "../../../../../api/resources";
import { Trans, useTranslation } from "react-i18next";
import routes, { dashboardRoute } from "../../../../../routes/routes";
import { useAuth } from "../../../../../auth/AuthContext";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AddCircleOutline,
  SwapHorizontalCircle,
  Undo,
} from "@mui/icons-material";
import { Popover } from "@mui/material";
import Button from "../../../Button/Button";
import { Form } from "../../../Form/Form";
import { useHelperDispatch } from "../../../Helper/HelperContext";
import { useTheme } from "../../../../../theme/ThemeContext";

export default function CompanySwitch() {
  const { t } = useTranslation(["common", "navigation"]);
  const {
    activeCompany,
    loadingActiveCompany,
    companies,
    loadingCompanies,
    reseller,
    // user,
    loadingUser,
  } = useAuth();
  const navigate = useNavigate();

  // popover
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);
  const dispatchHelper = useHelperDispatch();

  const [switching, setSwitching] = useState(false);

  const handleActivateCompany = async (companyID) => {
    setSwitching(true);
    const response = await api.setActiveCompany(companyID);
    if (response.ok) {
      handleClose();
      dispatchHelper({ type: "delete" }); // delete potential helper from previous active company
      window.location.href = dashboardRoute; // not using useNavigate because needs page refresh
    }
  };

  const handleAddCompany = () => {
    handleClose();
    navigate(routes.Company.root);
    window.location.reload();
  };

  const loading = loadingUser || loadingActiveCompany || loadingCompanies;

  if (reseller) return <></>;
  return (
    <div className="CompanySwitch">
      {!reseller && (
        <div
          className={["CompanySwitch-button", open && "open"]
            .filter(Boolean)
            .join(" ")}
        >
          <Button
            disabled={loading}
            title={t("navigation:companySwitch.list.title")}
            icon={<SwapHorizontalCircle />}
            onClick={handleClick}
          />
        </div>
      )}

      <Popover
        className="CompanySwitch-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {/* <span className="CompanySwitch-popover-title">
          {t("navigation:companySwitch.list.title")}
        </span>
        <span className="CompanySwitch-popover-hello">
          <Trans
            t={t}
            shouldUnescape
            tOptions={{ interpolation: { escapeValue: true } }}
            i18nKey="navigation:companySwitch.list.hello"
          >
            {{ user: user.name }}
            <span
              className="CompanySwitch-popover-hello-company"
              style={{ color: activeCompany.colour }}
            >
              {{ activeCompany: activeCompany.name }}
            </span>
          </Trans>
        </span> */}

        <CompanySwitchComponent
          switching={switching}
          companies={companies}
          activeCompany={activeCompany}
          reseller={reseller}
          onActivate={handleActivateCompany}
          onAdd={handleAddCompany}
        />
      </Popover>
    </div>
  );
}

function CompanySwitchComponent({
  switching,
  companies,
  activeCompany,
  reseller,
  onActivate,
  onAdd,
}) {
  const { t } = useTranslation(["common", "settings", "navigation"]);
  const isReseller = (company) => reseller && company.name === reseller.name;

  const [selectedCompany, setSelectedCompany] = useState({
    label: activeCompany.name,
    value: activeCompany.id,
  });

  const options = companies
    // Remove active company
    // .filter((company) => company.id !== activeCompany.id)
    // Remove reseller company
    .sort((companyA, companyB) => (companyA.name > companyB.name ? 1 : -1))
    .sort((company) => (company.id === activeCompany.id ? -1 : 1))
    .filter((company) => !isReseller(company))
    .map((company) => ({
      value: company.id,
      label: company.name,
    }));

  const handleSelect = (value) => {
    setSelectedCompany(value);
    onActivate(value.value);
  };

  const inputs = [
    {
      // label: t("navigation:companySwitch.list.otherCompanies"),
      type: "radio",
      name: "companies",
      value: selectedCompany,
      onChange: (value) => handleSelect(value),
      options: options,
    },
  ];

  return (
    <Fragment>
      <div className="CompanySwitch-popover-component">
        <Form
          externalLoading={switching}
          className="CompanySwitch-popover-component-switch"
          inputs={[{ data: inputs }]}
        />
      </div>

      <Button
        className="CompanySwitch-popover-add"
        onClick={onAdd}
        text={t("navigation:companySwitch.list.add")}
        icon={<AddCircleOutline style={{ fontSize: "larger" }} />}
        iconLeft
      />
    </Fragment>
  );
}

export function CompanySwitchBanner() {
  const { t } = useTranslation(["common", "navigation"]);
  const { activeCompany, loadingActiveCompany, loadingCompanies, reseller } =
    useAuth();

  const { theme } = useTheme();

  const handleActivateCompany = async (companyID) => {
    const response = await api.setActiveCompany(companyID);
    if (response.ok) {
      window.location.href = dashboardRoute; // not using useNavigate because needs page refresh
    }
  };

  if (loadingActiveCompany || loadingCompanies) return <></>;
  return (
    <div
      className="CompanySwitchBanner"
      style={{
        backgroundColor: reseller
          ? "var(--color-client-company)"
          : "var(--color-own-company)",
      }}
    >
      <div
        className="CompanySwitchBanner-container"
        style={{ color: reseller || theme ? "var(--color-leano-1)" : "white" }}
      >
        <div>
          <Trans
            t={t}
            shouldUnescape
            tOptions={{ interpolation: { escapeValue: true } }}
            i18nKey="navigation:companySwitch.banner.manage"
          >
            You are managing
            <span className="activeCompany" style={{ fontWeight: "700" }}>
              {{ activeCompany: activeCompany.name }}
            </span>
          </Trans>
        </div>
        {reseller && (
          <Button onClick={() => handleActivateCompany(reseller.id)}>
            <div
              style={{
                display: "flex",
                gap: "0.3rem",
              }}
            >
              <span style={{ textAlign: "right" }}>
                <Trans
                  t={t}
                  shouldUnescape
                  tOptions={{ interpolation: { escapeValue: true } }}
                  i18nKey="navigation:companySwitch.banner.back"
                >
                  Back to
                  <span style={{ fontWeight: "700" }}>
                    {{ resellerCompany: reseller.name }}
                  </span>
                </Trans>
              </span>
              <Undo fontSize="x-small" />
            </div>
          </Button>
        )}
      </div>
    </div>
  );
}
